import { useState, useEffect, useCallback } from 'react';
import { getProductCategories } from '../services/medusa/client';

// Categorías fallback cuando Medusa no está disponible
const FALLBACK_CATEGORIES = [
  { id: 'todo', handle: 'todo', name: 'Todo', description: '' },
  { id: 'sueros', handle: 'sueros', name: 'Sueros', description: 'Concentrados activos que penetran profundamente en la piel para tratar necesidades específicas.' },
  { id: 'tonicos', handle: 'tonicos', name: 'Tónicos', description: 'Preparan y equilibran tu piel después de la limpieza, optimizando la absorción de los activos.' },
  { id: 'hidratantes', handle: 'hidratantes', name: 'Hidratantes', description: 'Restauran y mantienen la barrera cutánea con hidratación profunda y duradera.' },
  { id: 'limpiadores', handle: 'limpiadores', name: 'Limpiadores', description: 'Eliminan impurezas respetando el equilibrio natural de tu piel.' },
  { id: 'tratamientos', handle: 'tratamientos', name: 'Tratamientos', description: 'Fórmulas especializadas para abordar condiciones específicas de la piel.' },
  { id: 'solares', handle: 'solares', name: 'Protección Solar', description: 'Protección avanzada contra rayos UVA y UVB sin comprometer la textura.' },
  { id: 'kits', handle: 'kits', name: 'Kits', description: 'Rutinas completas seleccionadas para simplificar tu cuidado diario.' },
  { id: 'sets', handle: 'sets', name: 'Sets', description: 'Combinaciones curadas para descubrir y regalar lo mejor de Physiology.' },
];

export function useCategories() {
  const [categories, setCategories] = useState(FALLBACK_CATEGORIES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchCategories = async () => {
      try {
        const medusaCategories = await getProductCategories();
        if (!cancelled && medusaCategories.length > 0) {
          // Agregar "Todo" al inicio y mapear las de Medusa
          const mapped = [
            { id: 'todo', handle: 'todo', name: 'Todo', description: '' },
            ...medusaCategories.map(cat => ({
              id: cat.handle || cat.id,
              handle: cat.handle,
              name: cat.name,
              description: cat.description || '',
              metadata: cat.metadata || {},
            }))
          ];
          setCategories(mapped);
        }
      } catch (error) {
        console.log('Medusa categorías no disponibles, usando fallback');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchCategories();
    return () => { cancelled = true; };
  }, []);

  const getCategoryByHandle = useCallback((handle) => {
    if (!handle || handle === 'todo') {
      return { name: 'Todos los productos', description: 'Explora nuestra colección completa de productos formulados con precisión científica.' };
    }
    return categories.find(cat => cat.handle === handle || cat.id === handle) || null;
  }, [categories]);

  return { categories, loading, getCategoryByHandle };
}
